/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type RecaptchaVersion = "V2" | "V3" | "%future added value";
export type AnimalPublicTagSearchResultQueryVariables = {
    tag: string;
    recaptchaResponse?: string | null | undefined;
    recaptchaVersion: RecaptchaVersion;
};
export type AnimalPublicTagSearchResultQueryResponse = {
    readonly animalPublicTagSearch: {
        readonly recaptchaErrorCode: string | null;
        readonly publicTagSearchResults: ReadonlyArray<{
            readonly " $fragmentRefs": FragmentRefs<"AnimalPublicTagSearchResultRow_searchResult">;
        }> | null;
    } | null;
    readonly configuration: {
        readonly " $fragmentRefs": FragmentRefs<"AnimalPublicTagSearchResultRow_configuration">;
    } | null;
};
export type AnimalPublicTagSearchResultQuery = {
    readonly response: AnimalPublicTagSearchResultQueryResponse;
    readonly variables: AnimalPublicTagSearchResultQueryVariables;
};



/*
query AnimalPublicTagSearchResultQuery(
  $tag: String!
  $recaptchaResponse: String
  $recaptchaVersion: RecaptchaVersion!
) {
  animalPublicTagSearch(tag: $tag, recaptcha: $recaptchaResponse, recaptchaVersion: $recaptchaVersion) {
    recaptchaErrorCode
    publicTagSearchResults {
      ...AnimalPublicTagSearchResultRow_searchResult
    }
  }
  configuration {
    ...AnimalPublicTagSearchResultRow_configuration
  }
}

fragment AnimalPublicTagSearchResultRow_configuration on Configuration {
  organisationContact
}

fragment AnimalPublicTagSearchResultRow_searchResult on PublicTagSearchResult {
  tagNumber
  animalName
  animalTypeDescription
  primaryBreedDescription
  secondaryBreedDescription
  ownerName
  mobilePhoneNumber
  homePhoneNumber
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "recaptchaResponse"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "recaptchaVersion"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "tag"
    } as any, v3 = [
        {
            "kind": "Variable",
            "name": "recaptcha",
            "variableName": "recaptchaResponse"
        } as any,
        {
            "kind": "Variable",
            "name": "recaptchaVersion",
            "variableName": "recaptchaVersion"
        } as any,
        {
            "kind": "Variable",
            "name": "tag",
            "variableName": "tag"
        } as any
    ], v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "recaptchaErrorCode",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "AnimalPublicTagSearchResultQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v3 /*: any*/),
                    "concreteType": "PublicTagSearch",
                    "kind": "LinkedField",
                    "name": "animalPublicTagSearch",
                    "plural": false,
                    "selections": [
                        (v4 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "PublicTagSearchResult",
                            "kind": "LinkedField",
                            "name": "publicTagSearchResults",
                            "plural": true,
                            "selections": [
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "AnimalPublicTagSearchResultRow_searchResult"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Configuration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "AnimalPublicTagSearchResultRow_configuration"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v2 /*: any*/),
                (v0 /*: any*/),
                (v1 /*: any*/)
            ],
            "kind": "Operation",
            "name": "AnimalPublicTagSearchResultQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v3 /*: any*/),
                    "concreteType": "PublicTagSearch",
                    "kind": "LinkedField",
                    "name": "animalPublicTagSearch",
                    "plural": false,
                    "selections": [
                        (v4 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "PublicTagSearchResult",
                            "kind": "LinkedField",
                            "name": "publicTagSearchResults",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tagNumber",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "animalName",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "animalTypeDescription",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "primaryBreedDescription",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "secondaryBreedDescription",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "ownerName",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mobilePhoneNumber",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "homePhoneNumber",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Configuration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "organisationContact",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "36008fa9524c4e21b4300d3b64e70583",
            "id": null,
            "metadata": {},
            "name": "AnimalPublicTagSearchResultQuery",
            "operationKind": "query",
            "text": "query AnimalPublicTagSearchResultQuery(\n  $tag: String!\n  $recaptchaResponse: String\n  $recaptchaVersion: RecaptchaVersion!\n) {\n  animalPublicTagSearch(tag: $tag, recaptcha: $recaptchaResponse, recaptchaVersion: $recaptchaVersion) {\n    recaptchaErrorCode\n    publicTagSearchResults {\n      ...AnimalPublicTagSearchResultRow_searchResult\n    }\n  }\n  configuration {\n    ...AnimalPublicTagSearchResultRow_configuration\n  }\n}\n\nfragment AnimalPublicTagSearchResultRow_configuration on Configuration {\n  organisationContact\n}\n\nfragment AnimalPublicTagSearchResultRow_searchResult on PublicTagSearchResult {\n  tagNumber\n  animalName\n  animalTypeDescription\n  primaryBreedDescription\n  secondaryBreedDescription\n  ownerName\n  mobilePhoneNumber\n  homePhoneNumber\n}\n"
        }
    } as any;
})();
(node as any).hash = '41a7ad3f2135fa30a3ff0f18330d9798';
export default node;
